import { render } from "./PrivacyPolicyControl.vue?vue&type=template&id=3382798a"
import script from "./PrivacyPolicyControl.vue?vue&type=script&lang=js"
export * from "./PrivacyPolicyControl.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__